module.exports = __webpack_public_path__ + "img/8pic.bc84d6d5.jpg";